import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LogData, CreateLogParams, LogLevel } from '../../types/dex';
import { RootState } from '../index';

/**
 * 日志状态接口
 */
interface LogState {
  logs: LogData[];
}

/**
 * 初始状态
 */
const initialState: LogState = {
  logs: []
};

/**
 * 日志Slice
 */
const logSlice = createSlice({
  name: 'log',
  initialState,
  reducers: {
    /**
     * 添加日志项
     */
    addLogItem: (state, action: PayloadAction<CreateLogParams | LogData>) => {
      const log = action.payload;
      // 如果已经是LogData格式，直接添加
      if ('timestamp' in log) {
        state.logs.push(log as LogData);
      } else {
        // 否则转换为LogData格式
        state.logs.push({
          level: log.level,
          message: log.message,
          timestamp: new Date().getTime(),
          walletIndex: log.walletIndex,
          data: log.data
        });
      }
      
      // 保持日志数量不超过1000条
      if (state.logs.length > 1000) {
        state.logs = state.logs.slice(-1000);
      }
    },
    
    /**
     * 清空日志
     */
    clearLogs: (state) => {
      state.logs = [];
    },
    
    /**
     * 批量添加日志
     */
    addLogs: (state, action: PayloadAction<LogData[]>) => {
      state.logs = [...state.logs, ...action.payload];
      
      // 保持日志数量不超过1000条
      if (state.logs.length > 1000) {
        state.logs = state.logs.slice(-1000);
      }
    }
  }
});

/**
 * 导出Action创建器
 */
export const { addLogItem, clearLogs, addLogs } = logSlice.actions;

/**
 * 导出选择器
 */
export const selectLogs = (state: RootState) => state.log.logs;
export const selectLogsByLevel = (state: RootState, level: LogLevel) => 
  state.log.logs.filter(log => log.level === level);
export const selectLogsByWallet = (state: RootState, walletIndex: number) => 
  state.log.logs.filter(log => log.walletIndex === walletIndex);

/**
 * 导出Reducer
 */
export default logSlice.reducer;
